module.exports = __webpack_public_path__ + "media/images/emblems/Flaesch_wappen-330175ed2896b681586c05da4dd54895.svg";